import { MapType } from '@/types';

export const parseQueryString = (queryString?: string) => {
  const qs = queryString ?? window.location.search;
  const params: MapType = {};
  const queryStringWithoutQuestionMark = qs.substring(1);
  const pairs = queryStringWithoutQuestionMark.split('&');

  pairs.forEach((pair) => {
    const [key, value] = pair.split('=');
    if (key) {
      params[key] = decodeURIComponent(value);
    }
  });

  return params;
};

export const getURLSegments = (url: string) => {
  try {
    const urlObj = new URL(url);
    const segments = urlObj.pathname.split('/');
    return { segments, segementLength: segments.length };
  } catch (error) {
    return {
      segments: [],
      segementLength: 0,
    };
  }
};

export const hasHashParam = (hashParam: string, delimiter = '&') => {
  const hash = window.location.hash.substring(1);

  const params = hash.split(delimiter);
  return params.some((param) => {
    const [key, value] = param.split('=');
    return key === hashParam;
  });
};

export const removeHashParam = (paramToRemove: string) => {
  const currentHash = window.location.hash.substring(1);

  const params = currentHash.split('&');

  const filteredParams = params.filter((param) => {
    const [key] = param.split('=');
    return key !== paramToRemove;
  });

  const newHash = filteredParams.join('&');

  if (newHash) {
    window.location.hash = `#${newHash}`;
  } else {
    window.history.replaceState(null, '', window.location.pathname + window.location.search);
  }
};

export const hasQueryParam = (param: string): boolean => {
  const searchParams = new URLSearchParams(window.location.search);
  return searchParams.has(param);
};

export const removeQueryParam = (param: string) => {
  const searchParams = new URLSearchParams(window.location.search);

  if (searchParams.has(param)) {
    searchParams.delete(param);

    const newQuery = searchParams.toString();
    const newUrl = newQuery ? `${window.location.pathname}?${newQuery}` : window.location.pathname;

    window.history.replaceState(null, '', newUrl);
  }
};
